import React from 'react';
import { formatValue, formatConfidence } from '../../utils/formatters';

const SiteTypeSection = ({ siteTypeData }) => {
    if (!siteTypeData || (
        !siteTypeData.type &&
        !siteTypeData.subType &&
        !siteTypeData.confidence &&
        !siteTypeData.primaryCta &&
        !siteTypeData.notes &&
        !(Array.isArray(siteTypeData.signals) ? siteTypeData.signals.length > 0 : siteTypeData.signals)
    )) {
        return null;
    }

    return (
        <div style={{ marginBottom: '30px' }}>
            <h4 style={{ marginBottom: '15px', color: '#e0e0e0', fontWeight: '600' }}>Site Type</h4>
            <div style={{
                display: 'grid',
                gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
                gap: '16px'
            }}>
                {(siteTypeData.type || siteTypeData.subType || siteTypeData.confidence || siteTypeData.primaryCta) && (
                    <div style={{
                        background: 'linear-gradient(135deg, rgba(23, 162, 184, 0.18), rgba(23, 162, 184, 0.05))',
                        border: '1px solid rgba(23, 162, 184, 0.35)',
                        borderRadius: '12px',
                        padding: '20px',
                        display: 'flex',
                        flexDirection: 'column',
                        gap: '16px',
                        gridColumn: '1 / -1'
                    }}>
                        <div>
                            <div style={{
                                fontSize: '12px',
                                color: '#a0a0a0',
                                textTransform: 'uppercase',
                                letterSpacing: '0.5px',
                                marginBottom: '10px',
                                fontWeight: '600'
                            }}>
                                Classification
                            </div>
                            <div style={{ display: 'flex', flexWrap: 'wrap', gap: '10px' }}>
                                {siteTypeData.type && (
                                    <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: '#17a2b8',
                                        color: '#fff',
                                        padding: '6px 14px',
                                        borderRadius: '999px',
                                        fontSize: '14px',
                                        fontWeight: 600
                                    }}>
                                        {formatValue(siteTypeData.type)}
                                    </span>
                                )}
                                {siteTypeData.subType && (
                                    <span style={{
                                        display: 'inline-flex',
                                        alignItems: 'center',
                                        backgroundColor: '#0f7889',
                                        color: '#fff',
                                        padding: '6px 14px',
                                        borderRadius: '999px',
                                        fontSize: '14px',
                                        fontWeight: 600
                                    }}>
                                        {formatValue(siteTypeData.subType)}
                                    </span>
                                )}
                            </div>
                        </div>

                        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '20px' }}>
                            {siteTypeData.confidence && (
                                <div>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#a0a0a0',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '6px',
                                        fontWeight: '600'
                                    }}>
                                        Confidence
                                    </div>
                                    <div style={{
                                        fontSize: '26px',
                                        fontWeight: 700,
                                        color: '#ffffff'
                                    }}>
                                        {formatConfidence(siteTypeData.confidence)}
                                    </div>
                                </div>
                            )}

                            {siteTypeData.primaryCta && (
                                <div>
                                    <div style={{
                                        fontSize: '12px',
                                        color: '#a0a0a0',
                                        textTransform: 'uppercase',
                                        letterSpacing: '0.5px',
                                        marginBottom: '6px',
                                        fontWeight: '600'
                                    }}>
                                        Primary Call To Action
                                    </div>
                                    <div style={{
                                        fontSize: '16px',
                                        fontWeight: 600,
                                        color: '#e0f7fa'
                                    }}>
                                        {formatValue(siteTypeData.primaryCta)}
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>
                )}

                {(siteTypeData.notes || (Array.isArray(siteTypeData.signals) ? siteTypeData.signals.length > 0 : siteTypeData.signals)) && (
                    <div style={{
                        display: 'grid',
                        gap: '16px',
                        gridColumn: '1 / -1'
                    }}>
                        {siteTypeData.notes && (
                            <div style={{
                                backgroundColor: '#2d2d2d',
                                border: '1px solid #404040',
                                borderRadius: '10px',
                                padding: '20px'
                            }}>
                                <h4 style={{
                                    margin: '0 0 12px 0',
                                    color: '#e0e0e0',
                                    fontWeight: '600'
                                }}>
                                    Notes
                                </h4>
                                <p style={{
                                    margin: 0,
                                    color: '#d0d0d0',
                                    lineHeight: '1.7',
                                    fontSize: '15px'
                                }}>
                                    {formatValue(siteTypeData.notes)}
                                </p>
                            </div>
                        )}

                        {(Array.isArray(siteTypeData.signals) ? siteTypeData.signals.length > 0 : siteTypeData.signals) && (
                            <div style={{
                                backgroundColor: '#252525',
                                border: '1px solid #333333',
                                borderRadius: '10px',
                                padding: '20px'
                            }}>
                                <h4 style={{
                                    margin: '0 0 12px 0',
                                    color: '#e0e0e0',
                                    fontWeight: '600'
                                }}>
                                    Signals
                                </h4>
                                {Array.isArray(siteTypeData.signals) ? (
                                    <ul style={{
                                        margin: 0,
                                        paddingLeft: '20px',
                                        color: '#c0c0c0',
                                        lineHeight: '1.7',
                                        fontSize: '14px'
                                    }}>
                                        {siteTypeData.signals.map((signal, index) => (
                                            <li key={index}>
                                                {formatValue(signal)}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <p style={{
                                        margin: 0,
                                        color: '#c0c0c0',
                                        lineHeight: '1.7',
                                        fontSize: '14px'
                                    }}>
                                        {formatValue(siteTypeData.signals)}
                                    </p>
                                )}
                            </div>
                        )}
                    </div>
                )}
            </div>
        </div>
    );
};

export default SiteTypeSection;






